import type { NegativeNews } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { NegativeNewsApi } from 'api';
import { NEGATIVE_NEWS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useNegativeNews(dispensary_id: string, startDate?: string, endDate?: string) {
  const { userBankId } = useUser();
  const negativeNewsApi = new NegativeNewsApi();

  const { data: negativeNews, isLoading: isLoadingNegativeNews } = useQuery<NegativeNews[]>({
    enabled: !!userBankId && !!dispensary_id,
    queryKey: [NEGATIVE_NEWS_KEY, userBankId, dispensary_id, startDate, endDate],
    queryFn: () => negativeNewsApi.getNegativeNewsForCrb(userBankId, dispensary_id, startDate, endDate),
    meta: {
      snackbarErrorMessage:
        'There was an issue getting negative news. Please contact support if the problem persists.'
    }
  });

  return { negativeNews, isLoadingNegativeNews };
}
